var React = require('react');

function Triangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.8564 0.541589C13.2285 0.228552 13.7719 0.228552 14.1439 0.541589L26.5574 10.9848C27.2713 11.5854 26.8466 12.75 25.9136 12.75H1.08676C0.153781 12.75 -0.270941 11.5854 0.442991 10.9848L12.8564 0.541589Z","fill":"#A4202F"}));
}

Triangle.defaultProps = {"width":"27","height":"13","viewBox":"0 0 27 13","fill":"none"};

module.exports = Triangle;

Triangle.default = Triangle;
